import { forwardRef } from 'react';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import { usePalette } from 'src/hooks';

// eslint-disable-next-line react/prop-types
export const CheckboxCell = forwardRef<HTMLInputElement, CheckboxProps>(({ sx, ...props }, ref) => {
  const { text } = usePalette();

  return <Checkbox ref={ref as never} sx={{ color: text.primary, ...sx }} {...props} />;
});
